<template>
    <div id="shiftDetailList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">{{pageTitle}}</div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'shiftDetailList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange" :moduleName="'shiftDetailList'" :position="'top'">
                            </custom-pagination>

                            <vue-good-table
                                ref="ShiftDetailList"
                                mode="remote"
                                title="Shift Detail"
                                @on-page-change="onPageChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                :totalRows="totalRecords"
                                :columns="userColumns"
                                :rows="rows"
                                :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown:dropDownPerPage,
                                    dropdownAllowAll: false,
                                }"

                                :search-options="{
                                enabled: false,
                                }">
                            </vue-good-table>
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div v-if="props.column.field == 'task_description'">
                                        <span v-fp-html="props.row.task_description"></span>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
    name: "ShiftDetailList",
    metaInfo() {
        return {
            title: "Shift Detail List | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        pageTitle:"Shift Detail List",
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label: 'User',
                field: 'user',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "User", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Task Description',
                field: 'task_description',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                sortable: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Task Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html: true
            },
            {
                label: 'Facility',
                field: 'location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Facility", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Start Time',
                field: 'start_time',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Start Time", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'End Time',
                field: 'end_time',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "End Time", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Duration',
                field: 'duration',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Duration", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Updated Duration',
                field: 'updated_duration',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Updated Duration", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list'
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_shift_detail') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {
    },
    mounted: function() {
        var self = this;

        self.getPermissions();
        if(self.$route.query.flag == 'gangsheetReport'){
              self.pageTitle = "Gangsheet Details";
        }
    },
    methods: {
        cancelAll: function (cancelAll) {
              this.$refs.ShiftDetailList.unselectAllInternal();
            },
        loadList: function() {

            var self = this;

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/shift-detail/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'shift-detail-list')
                }
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ETK/ShiftDetailList.vue